import { type MetaFunction, Link, Outlet } from 'react-router'
import { Icon } from '#app/components/ui/icon.tsx'
import { siteTitle } from '#app/utils/global.ts'

export default function ControlsRoute() {
  return (
    <>
      <aside
        className="bg-muted fixed top-0 left-0 z-40 mt-20 h-screen w-64"
        aria-label="Sidebar"
      >
        <div className="h-full overflow-y-auto px-8 py-4">
          <h1 className="text-h4">Controls</h1>
          <ul className="my-2 font-medium">
            <li>
              <Link prefetch="intent" to={'users'}>
                <Icon className="text-3" name="avatar">
                  Users
                </Icon>
              </Link>
            </li>
            <li>
              <Link prefetch="intent" to={'training'}>
                <Icon className="text-3" name="dashboard">
                  Training
                </Icon>
              </Link>
            </li>
            <li>
              <Link prefetch="intent" to={'unit-tests'}>
                <Icon className="text-3" name="checkbox">
                  Unit Tests
                </Icon>
              </Link>
            </li>
            <li>
              <Link prefetch="intent" to={'user-lesson-plans'}>
                <Icon className="text-3" name="pencil-2">
                  User Lesson Plans
                </Icon>
              </Link>
            </li>
          </ul>
          <h1 className="text-h4">Email Previews</h1>
          <ul className="my-2 font-medium">
            <li>
              <Link prefetch="intent" to={'email/sign-up'}>
                <Icon className="text-3" name="person">
                  Sign Up
                </Icon>
              </Link>
            </li>
            <li>
              <Link prefetch="intent" to={'email/reset-password'}>
                <Icon className="text-3" name="lock-closed">
                  Reset Password
                </Icon>
              </Link>
            </li>
          </ul>
        </div>
      </aside>
      <main id="main-content" className="w-full pr-8 pl-64">
        <div className="overflow-x-scroll pl-8">
          <Outlet />
        </div>
      </main>
    </>
  )
}

export const meta: MetaFunction = () => {
  return [{ title: `Controls | ${siteTitle}` }]
}
